import { render, staticRenderFns } from "./SectionTypesSection.vue?vue&type=template&id=f3436374&"
import script from "./SectionTypesSection.vue?vue&type=script&lang=js&"
export * from "./SectionTypesSection.vue?vue&type=script&lang=js&"
import style0 from "./SectionTypesSection.vue?vue&type=style&index=0&id=f3436374&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports